export default "__VITE_ASSET__ChyT1hBs__"